export var getFieldNameFromLabel = function getFieldNameFromLabel(label) {
  return label.toLowerCase().replace(/\s+/g, '');
};
export var extractFormFields = function extractFormFields(template) {
  var regex = /\{\{([^}]+)\}\}/g;
  var fields = [];
  var match;

  while ((match = regex.exec(template)) !== null) {
    var label = match[1];
    var fieldName = getFieldNameFromLabel(label);
    fields.push({
      label: label,
      fieldName: fieldName
    });
  }

  return fields;
};
export var buildPromptText = function buildPromptText(values, template) {
  var fields = extractFormFields(template);
  var fieldMap = {};
  fields.forEach(function (field) {
    var _values$key;

    var key = field.fieldName;
    fieldMap[key] = (_values$key = values[key]) === null || _values$key === void 0 ? void 0 : _values$key.toString();
  });
  var result = template === null || template === void 0 ? void 0 : template.replace(/\{\{([^}]+)\}\}/g, function (match, label) {
    var fieldKey = getFieldNameFromLabel(label);
    return fieldMap[fieldKey] || '';
  });

  if (values.additionalInfo) {
    result += ' ' + values.additionalInfo;
  }

  return result.trim();
};